import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-ac-letter-harry-potter-04-hut-on-the-rock",
  name: `Harry Potter Acceptance Letter\n'Hut-on-the-Rock'`,
  nameFormatted: {
    primary: "Harry Potter Acceptance Letter",
    secondary: "'Hut-on-the-Rock'",
  },
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
